<template>
    <div>
    
        <h4 class="mb-4 text-2xl truncate">% Positive Customer Reviews per Category</h4>


        <vue-apex-charts class="-mb-6" style="margin-bottom: -1rem;"
        type="radar" height="260" :options="chartOptions" :series="series" />

    </div>

</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
    props: {
        ship: {
            type: Object,
            required: true
        }
    },
	computed: {
		series() {
            return [
				{
                    name: 'benchmark',
                    data: [
                        this.ship.cluster_benchmark.service_score.replace(',', '.')*1,
                        this.ship.cluster_benchmark.food_beverage_score.replace(',', '.')*1,
                        this.ship.cluster_benchmark.cabin_score.replace(',', '.')*1,
                        this.ship.cluster_benchmark.onboard_facilities_score.replace(',', '.')*1,
                        this.ship.cluster_benchmark.entertainment_score.replace(',', '.')*1,
                        this.ship.cluster_benchmark.onboard_activities_score.replace(',', '.')*1,
                        this.ship.cluster_benchmark.wifi_score.replace(',', '.')*1                        
                    ],
                },
                {
                    name: 'ship',
                    data: [
                        this.ship.cluster.service_score.replace(',', '.')*1,
                        this.ship.cluster.food_beverage_score.replace(',', '.')*1,
                        this.ship.cluster.cabin_score.replace(',', '.')*1,
                        this.ship.cluster.onboard_facilities_score.replace(',', '.')*1,
                        this.ship.cluster.entertainment_score.replace(',', '.')*1,
                        this.ship.cluster.onboard_activities_score.replace(',', '.')*1,
                        this.ship.cluster.wifi_score.replace(',', '.')*1
                    ]
                }
                ]
        },
        chartOptions() {
            return {
                labels: ['Service', 'Food & Beverage', 'Cabin', 'Onboard Facilities', 'Entertainment', 'Onboard Activities', 'Wifi'],
                yaxis: {
                    show: false
                },
                xaxis: {
                    labels: {
                        style: {
							colors: '#626262',
							fontSize: '1rem',
							fontFamily: 'Montserrat, Helvetica, Arial, sans-serif'
						},
                    }
                },
                grid: {
                    show: true
                },
                legend: { show: true },
                chart: {
                    toolbar: {
                        show: false
                    },
                    fontFamily: 'Montserrat, Helvetica, Arial, sans-serif',
                },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ['#cccccc','#e44a7f']
                },
                colors: ['#d9d9d963','#e44a7f23'],
                plotOptions: {
                    radar: {
                        polygons: {
                            strokeColors: ['#efefef'],
                            connectorColors: '#efefef'
                        }
                    }
                },
                markers: {
                    size: 0
                },
				grid: {
					padding: {
						top: -60,
						left: -30,
						right: -30,
                        bottom: -70,
					}
				}
            }
        }
	},
	components: {
		VueApexCharts
    }
}
</script>